function twofatypeSelector() {
  var directive = {
    template: require('./twofatypeSelector.html'),
    restrict: 'E',
    replace: true,
    controller: TwofatypeSelectorController,
    controllerAs: 'twofatypeSelectorController',
    bindToController: true,
    scope: {
      twofactorSelectionList: '='
    }    
  };

  function TwofatypeSelectorController($scope, $window) {
    var vm = this;
    vm.isOpen = false;
    vm.focusIndex = -1;
    vm.twofactorSelectionList = $scope.twofactorSelectionList;

    vm.changetwofatype = function(twofatype) {
      $window.location.replace(twofatype.twoFaRedirectUrl);
    };

    vm.keyDown = function(e) {
      switch (e.keyCode) {
        case 32:
        case 13:
          vm.isOpen = !vm.isOpen;
          if (vm.isOpen) {
            vm.focusIndex = -1;
          }
          break;
        case 40:
        case 9:
          if (vm.isOpen) {
            e.preventDefault();
            vm.focusIndex = (vm.focusIndex >= vm.twofactorSelectionList.length - 1) ? 0 : vm.focusIndex + 1;
            vm.changeFocus(vm.focusIndex);
          }
          break;
        case 38:
          if (vm.isOpen) {
            vm.focusIndex = (vm.focusIndex <= 0) ? vm.twofactorSelectionList.length - 1 : vm.focusIndex - 1;
            vm.changeFocus(vm.focusIndex);
          }
          break;
        case 27:
          var dropdown = document.getElementById('twoFaTypeSelectorSpan');
          dropdown.focus();
      }
    };

    vm.changeFocus = function(i) {
      var el = document.getElementById("twoFaType-" + i);
      el.focus();
    };

    vm.selectByKeyDown = function(e, twoFaType) {
      switch (e.keyCode) {
        case 32:
        case 13:
          vm.changetwofatype(twoFaType);
          break;
      }
    };

  };

  return directive;
};
export default twofatypeSelector;


// WEBPACK FOOTER //
// ./src/login/2fa/twofatypeselector/twofatypeSelector.js